<body>
    <ul>
        <div>
            <div *ngIf="dataLoaded">
                <div class="cabecalho">
                    <div class="informacao">
                        <div>
                            <button (click)="getItemsFromJetta()">Atualizar</button>
                            <button (click)="salvar()">Salvar</button>
                        </div>
                        <div class="informacao">
                            <label for="dataLoad">Último carregamento: </label>
                            <input name="dataLoad" type="text" disabled
                                [value]="lastLoadTCM_SP | date:'dd/MM/yyyy hh:mm'">
                        </div>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar" [style.width]="getProgressWidth()"></div>
                    </div>
                </div>

                <!-- <table>
                    <tr>
                        <th class="blue-text">
                            <a class="blue-text">Descrição da Roterização</a>
                        </th>
                        <th class="blue-text">
                            <a class="blue-text">Data da Roterização</a>
                        </th>
                    </tr>
                    <tr *ngFor="let item of items">
                        <td>{{ item.description }}</td>
                        <td>{{ item.date | date:'dd/MM/yyyy' }}</td>
                    </tr>
                    <tr>
                        <th class="blue-text">
                            <a class="blue-text">Veículo</a>
                        </th>
                        <th class="blue-text">
                            <a class="blue-text">Placa</a>
                        </th>
                    </tr>

                    <ng-container *ngFor="let routeArray of routes">
                        <tr *ngFor="let route of routeArray">
                            <td>
                                <ul>
                                    <li *ngFor="let transport of route.result.transports">{{ transport.descricao }}</li>
                                </ul>
                            </td>
                            <td>
                                <ul>
                                    <li *ngFor="let transport of route.result.transports">{{ transport.plate }}</li>
                                </ul>
                            </td>
                        </tr>
                    </ng-container>

                </table> -->

                <table>
                    <tr>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Descrição da Roterização</a>
                        </th>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Data da Roterização</a>
                        </th>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Total Rotas</a>
                        </th>
                    </tr>
                    <tr *ngFor="let item of items">
                        <td colspan="2">{{ item.description }}</td>
                        <td colspan="2">{{ item.date | date:'dd/MM/yyyy' }}</td>
                        <td colspan="2">{{ routes[0].length }}</td>
                    </tr>
                    <tr>
                        <th class="blue-text">
                            <a class="blue-text">Veículo</a>
                        </th>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Distância</a>
                        </th>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Peso</a>
                        </th>
                        <th class="blue-text" colspan="2">
                            <a class="blue-text">Placa</a>
                        </th>
                        <!-- <th class="blue-text">
                  <a class="blue-text">Placa</a>
                </th> -->
                    </tr>

                    <ng-container *ngFor="let routeArray of routes">
                        <tr *ngFor="let route of routeArray">
                            <td>{{ route.result.transports[0].descricao }}
                                <!-- <ul>
                      <li >{{ route.result.transports.descricao }}</li>
                    </ul> -->
                            </td>
                            <td colspan="2">{{ route.result.distance }}
                                <!-- <ul>
                      <li>{{ route.result.distance }}</li>
                    </ul> -->
                            </td>
                            <td colspan="2">{{ route.result.transports[0].weightLoaded }}
                                <!-- <ul>
                      <li *ngFor="let transport of route.result.transports">{{ route.result.transports.weightLoaded }}</li>
                    </ul> -->
                            </td>
                            <td>{{ route.result.transports[0].plate }}
                                <!-- <ul>
                      <li *ngFor="let transport of route.result.transports">{{ transport.plate }}</li>
                    </ul> -->
                            </td>
                        </tr>
                    </ng-container>

                </table>
            </div>
        </div>
    </ul>
</body>

<div *ngIf="isLoading" class="spinner-overlay">
    <div class="spinner">
        <mat-spinner></mat-spinner>
    </div>
</div>